// extracted by mini-css-extract-plugin
module.exports = {"App":"_3UfnqQ1e0CSI6iL23n1Joy","contents":"_2pLvLAJLnRm4Lmz8pQCxZc"};